const EMPTY = '';
const ARTICLE = 'Article';
const BLOG = 'Blog';
const RECAP = 'mlb_recap';
const RECAP_GAMEDAY = 'game-recap';
const PREVIEW_STORY = 'Preview Story';

class ContentGraphArticle {

    constructor (article) {
        const { slug = EMPTY, headline = EMPTY, body, summary, contentDate, templateUrl = '', url} = article;
        this.id = this.slug = slug;
        this.linkId = slug;
        this.headline = headline;
        this.body = body;
        this.blurb = summary;
        this.templateUrl = templateUrl;
        this.contentDate = contentDate;

        this.parseData(article);
    }

    tagParser(tag) {
        if(Object.keys(tag).length === 0) {
            return;
        }
        const type = tag && tag.type;
        const title = tag && tag.title;

        if (title) {
            if (title === RECAP || title === RECAP_GAMEDAY) {
                this.isRecap = true;
            }
            if (title === PREVIEW_STORY) {
                this.isPreviewStory = true;
            }
            if (title === ARTICLE) {
                this.isArticle = true;
            }
            if (title === BLOG) {
                this.isBlog = this.isCut4 = true;
            }
        }

        if (type === 'team' && tag.team?.id) {
            this.teamId = tag.team.id;
        }
    }

    parseData (data) {
        var tags = data.tags;

        this.isBlog = this.isCut4 = false;
        this.isArticle = false;
        this.isRecap = false;
        this.isPreviewStory = false;

        if (tags.length) {
            tags.forEach(this.tagParser, this);
        }
    }
};


export default ContentGraphArticle;
